<template>
  <form name="recurringOrderBasket">
    <div class="card__header">
      <p class="card__title">Basket</p>
      <p class="card__subtitle">Click on the icons to set up your delivery for each selected days. There is no mimimum basket, and the delivery fee will not change.</p>
    </div>
    <div class="card__content">
      <div class="orderDays">
        <div class="orderDay" v-for="_day in $data._days">
          <span class="orderDay__day"
                v-bind:class="{ 'is-active': (currentDay === _day.long), 'is-selected': days.includes(_day.long), 'is-disabled': !days.includes(_day.long) }"
                v-on:click="selectDay(_day.long)">{{ _day.short }}</span>
        </div>
      </div>
    </div>
    <div class="card__content">
      <label for="slot" class="form__label">Time slot</label>
      <select id="slot" class="form__control" name="slot" v-model="$parent.cart[currentDay]['time_slot_id']" v-on:change="checkForNext()">
        <option :value="slot.id" v-for="(slot) in slots" :disabled="slot.available === false">
          {{ slot.humanized_slot }} (+ £{{ slot.service_fee.recurring / 100 }}) {{ slot.available === false ? '(time slot full)' : '' }}
        </option>
      </select>
      <p class="form__notice">Select your favorite time slot</p>
    </div>
    <div class="card__content">
      <p class="card__subheader">Products</p>
      <ul class="tabs tabs--sm nav" id="productsNav" role="tablist">
        <li class="tab__wrapper" role="presentation" v-for="(tab, index) in tabs">
          <a v-if="tab" :class="['tab', (index == Object.keys(tabs)[0] ? 'active' : '')]"
            :id="tab.category.slug+'-tab'" data-toggle="tab" :href="'#'+tab.category.slug" role="tab">
            {{ tab.category.name }}
          </a>
        </li>
      </ul>
      <div class="tabs__content" id="myTabContent">
        <div v-for="(tab, index) in tabs" v-if="tab"
          :class="['tab__target', (index == Object.keys(tabs)[0] ? 'show active' : '')]" :id="tab.category.slug"
          role="tabpanel">
          <div class="row product__infosWrapper">
            <div class="col-md-6" v-for="product in tab.products">
              <div class="product__infos" :class="{ 'product__unavailable': (product.is_tracked && product.stock === 0) }">
                <div class="product__image"><img :src="'/' + product.image" class="img-fluid" alt=""/></div>
                <div class="product__meta">
                  <div class="product__header">
                    <p class="text-16 product__title">{{ product.name }}</p>
                    <div class="qty__wrapper">
                      <button type="button" class="button button--sm button--icon button--grey"
                              v-on:click="setQuantity(product, 'ACTION_LESS')">
                        <icon-minus></icon-minus>
                      </button>
                      <p class="text-16 qty">{{ $parent.cart[currentDay]['products'][product.id].qty }}</p>
                      <button type="button" class="button button--sm button--icon button--grey"
                              v-on:click="setQuantity(product, 'ACTION_MORE')">
                        <icon-plus></icon-plus>
                      </button>
                    </div>
                  </div>
                  <div>
                    <div class="text-12">
                      <template v-if="product.food_pairing">
                        {{ product.food_pairing }}.
                      </template>
                      <v-clamp autoresize :max-lines="3">
                        {{ product.description_short }}
                        <template #after="{ toggle, clamped, expanded }">
                          <button v-if="clamped == true || expanded == true" @click="toggle" type="button" class="product__expand button button--xs button--icon button--grey">
                            <template v-if="clamped == true"><icon-chevron-down></icon-chevron-down></template>
                            <template v-else><icon-chevron-up></icon-chevron-up></template>
                          </button>
                        </template>
                      </v-clamp>
                    </div>
                    <div class="mt-05">
                      <!-- product discount -->
                      <!-- <p class="tag tag--sm tag--primary" v-if="product.id === 27 || product.id === 26 || product.id === 53 || product.id === 85 || product.id === 86">15% off</p> -->
                      <span class="text-14 text--bold">
                        £{{ product.price | setDecimals }}
                        <!-- product discount -->
                        <!-- <span class="text--strikeThrough text--regular text--alt">
                          <template v-if="product.id === 27">£4.75</template>
                          <template v-if="product.id === 26">£5.20</template>
                          <template v-if="product.id === 53">£4.75</template>
                          <template v-if="product.id === 85">£4.20</template>
                          <template v-if="product.id === 86">£4.20</template>
                        </span> -->
                      </span>
                    </div>
                    <p class="text-12 text-error mt-05 text--bold" v-if="product.is_tracked && (product.stock - $parent.cart[currentDay]['products'][product.id].qty) === 0">Out of stock</p>
                    <p class="text-12 text-error mt-05 text--bold" v-else-if="product.is_tracked && (product.stock - $parent.cart[currentDay]['products'][product.id].qty) <= 5">Only {{ product.stock - $parent.cart[currentDay]['products'][product.id].qty }} remaining</p>
                    <p class="text-12 mt-05">
                      <template v-if="product.start_sale || product.end_sale">
                        Available
                        <span v-if="product.start_sale">From {{ dateFormat(product.start_sale) }}</span>
                        <span v-if="product.end_sale">to {{ dateFormat(product.end_sale) }}</span>
                      </template>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="errors.length" class="form__notice form__notice--error mt-3">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </div>
    </div>
    <div class="card__actions">
      <button type="button" class="button button--md button--grey" v-on:click="prevStep()">Back</button>
      <button type="button" class="button button--md button--secondary" v-on:click="nextStep()">Next</button>
    </div>

  </form>
</template>

<script>

import VClamp from 'vue-clamp'

export default {

  components: {
    VClamp
  },

  data() {
    return {
      errors: [],
      currentDay: null,
      currentDayIndex: 0,
      days: [],
      slots: [],
      slot: null,
      tabs: []
    }
  },

  beforeMount() {
    this.$parent.products.map((p) => {
      p.categories.map((c) => {
        if (!this.tabs[c.id]) {
          this.tabs[c.id] = {
            category: c,
            products: [],
          };
        }
        this.tabs[c.id].products.push(p);
      });
    });

    this.tabs = this.tabs.sort((a,b) => {
      return a.category.rgt - b.category.rgt;
    });

    this.currentDay = Object.keys(this.$parent.cart)[this.currentDayIndex];

    this.getSlots(this.currentDay);

    Object.keys(this.$parent.cart).forEach((day) => {
      this.days.push(day);
    });

    // Set config by day : products and slot
    Object.keys(this.$parent.cart).forEach((day) => {
      if (!('products' in this.$parent.cart[day])) {
        Vue.set(this.$parent.cart[day], 'products', {});
        Vue.set(this.$parent.cart[day], 'slot', '');

        this.$parent.products.forEach((element) => {
          if (!(this.$parent.cart[day]['products'][element.id])) {
            Vue.set(this.$parent.cart[day]['products'], element.id, Object.assign({}, element));
            Vue.set(this.$parent.cart[day]['products'][element.id], 'qty', 0);
          }
        });
      }
    });
  },

  methods: {
    setQuantity(product, action) {
      if (action === 'ACTION_MORE') {
        if (this.$parent.cart[this.currentDay]['products'][product.id].qty < 15) {
          if (product.is_tracked) {
            if (this.$parent.cart[this.currentDay]['products'][product.id].qty < product.stock) {
              this.$parent.cart[this.currentDay]['products'][product.id].qty++;
            }
          }
          else {
            this.$parent.cart[this.currentDay]['products'][product.id].qty++;
          }
        }
      } else {
        if (this.$parent.cart[this.currentDay]['products'][product.id].qty > 0) {
          if (product.is_tracked) {
            if (this.$parent.cart[this.currentDay]['products'][product.id].qty <= product.stock) {
              this.$parent.cart[this.currentDay]['products'][product.id].qty--;
            }
          }
          else {
            this.$parent.cart[this.currentDay]['products'][product.id].qty--;
          }
        }
      }
    },

    getSlots(day) {
      axios.post("/api/timeslot/day", {
        day: day
      }).then(res => {
        this.slots = res.data.datas;

        this.slots = this.slots.filter((slot) => {
          return this.$parent.halfDays.find((halfDay => halfDay.id === slot.half_day_id));
        });
      }).catch(error => console.log(error));
    },

    selectDay(day) {
      if (Object.keys(this.$parent.cart[day]['products']).length > 0) {
        this.currentDay = day;
        this.getSlots(this.currentDay);
      }
    },

    checkForNext() {
      if (this.slots && this.$parent.cart[this.currentDay]['time_slot_id']) {
        this.$parent.cart[this.currentDay]['time_slot_id'] = this.slots.find((timeSlot) => timeSlot.id === this.$parent.cart[this.currentDay]['time_slot_id']).id;
      }

      const canGo = [];
      Object.keys(this.$parent.cart).forEach((day) => {
        let dayIsReady = false;
        Object.keys(this.$parent.cart[day]['products']).forEach((product) => {
          if (this.$parent.cart[day]['products'][product].qty > 0) {
            dayIsReady = true;
          }
        });

        if (!this.$parent.cart[day]['time_slot_id']) {
          dayIsReady = false;
        }
        canGo.push(dayIsReady);
      });

      const sameValues = canGo.every((val, i, arr) => val === arr[0]);
      return sameValues && canGo[0] === true;
    },

    nextStep() {
      this.errors = [];
      if (this.checkForNext()) {
        this.$parent.step = 'SUMMARY';
      }
      else {
        this.errors.push('Please make sure you have selected a time slot and at least one product for each selected day.');
      }
    },

    prevStep() {
      this.$parent.step = 'NEW';
      this.checkForNext();
    },

    dateFormat(date) {
      function pad(s) { return (s < 10) ? '0' + s : s; }
      let d = new Date(date);
      return [pad(d.getDate()), pad(d.getMonth()+1)].join('/');
    }
  }
}
</script>
